import { useRef, useEffect } from 'react';
import { useStore } from 'react-redux';
import { Modal, Box } from '@mui/material';
import { ChatBox } from '@dpdgroupuk/cc-chat-fe';
import PropTypes from 'prop-types';

const ChatModal = ({
  open,
  onClose,
  onChatEnd,
  chatConfig,
  parcelCode,
  collectionReference,
}) => {
  const focusRef = useRef(null);
  const store = useStore();
  const originalDispatch = useRef(null);
  const interceptActive = useRef(false);
  const chatEndCalled = useRef(false);

  useEffect(() => {
    if (open && focusRef.current) {
      focusRef.current.focus();
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      chatEndCalled.current = false;
    }
  }, [open]);

  useEffect(() => {
    if (open && !interceptActive.current) {
      originalDispatch.current = store.dispatch;
      interceptActive.current = true;
      const interceptDispatch = action => {
        if (
          action?.type === 'ACT_RESET_CONFIG_STATE' &&
          !chatEndCalled.current
        ) {
          chatEndCalled.current = true;
          if (onChatEnd) {
            onChatEnd();
          }
        }
        if (
          originalDispatch.current &&
          typeof originalDispatch.current === 'function'
        ) {
          return originalDispatch.current(action);
        } else {
          return store.dispatch(action);
        }
      };
      store.dispatch = interceptDispatch;
    }

    return () => {
      if (interceptActive.current && originalDispatch.current) {
        store.dispatch = originalDispatch.current;
      }
    };
  }, [open, onChatEnd, store]);

  useEffect(() => {
    if (!open && interceptActive.current) {
      setTimeout(() => {
        originalDispatch.current = null;
        interceptActive.current = false;
        chatEndCalled.current = false;
      }, 50);
    }
  }, [open]);

  const handleChatBoxHide = () => {
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
      keepMounted
    >
      <Box
        ref={focusRef}
        tabIndex={-1}
        sx={{ width: '650px', maxWidth: '100%' }}
      >
        <ChatBox
          initialConfig={chatConfig}
          hideChat={handleChatBoxHide}
          customizations={{ hideEmailByAdvisorsBusy: true }}
          ratingEnabled={false}
          parcelCode={parcelCode || null}
          collectionReference={collectionReference || null}
        />
      </Box>
    </Modal>
  );
};

ChatModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChatEnd: PropTypes.func,
  chatConfig: PropTypes.object.isRequired,
  parcelCode: PropTypes.string,
  collectionReference: PropTypes.string,
};

export default ChatModal;
